import React, { useContext } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useDeviationViewContext } from '../../../Context';
import DesktopDeviationPage from '../../DesktopDeviationPage';
import FullscreenDeviationPage from '../../FullscreenDeviationPage';
import MobileDeviationPage from '../../MobileDeviationPage';
import { getDeviationType, isLegacyStatus } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import SimplePage from '../SimplePage';
import DesktopTextualPage from '../../DesktopTextualPage';
import DesktopStatusPage from '../../DesktopStatusPage';
import MobileTierPage from '../../MobileTierPage';
import DesktopTierPage from '../../DesktopTierPage';

export interface Props {
  deviation: PapiDeviation;
}

const DeviationPageContent: React.FC<Props> = ({ deviation }) => {
  const isMobile = useContext(MobileContext);
  const { isFullscreen } = useDeviationViewContext();
  const deviationType = getDeviationType(deviation);

  if (isMobile) {
    switch (deviationType) {
      case DeviationTypes.TIER:
        return <MobileTierPage deviation={deviation} />;
      case DeviationTypes.COMMISSION:
        return <MobileDeviationPage deviation={deviation} withoutSidebar />;
      default:
        return <MobileDeviationPage deviation={deviation} />;
    }
  }

  if (isFullscreen) {
    return <FullscreenDeviationPage deviation={deviation} />;
  }

  switch (deviationType) {
    case DeviationTypes.COMMISSION:
      return <SimplePage deviation={deviation} withoutSidebar />;
    case DeviationTypes.STATUS:
      if (!isLegacyStatus(deviation)) {
        return <DesktopStatusPage deviation={deviation} />;
      }
      return <SimplePage deviation={deviation} />;
    case DeviationTypes.POLL:
      return <SimplePage deviation={deviation} />;
    case DeviationTypes.JOURNAL:
    case DeviationTypes.LITERATURE:
      return <DesktopTextualPage deviation={deviation} />;
    case DeviationTypes.TIER:
      return <DesktopTierPage deviation={deviation} />;
    default:
      return <DesktopDeviationPage deviation={deviation} />;
  }
};
DeviationPageContent.displayName = 'DeviationPageContent';

export default DeviationPageContent;
